import React from "react";
import { Outlet } from "react-router-dom";
import NotAuthorized from "../pages/Errors/NotAuthorized";
import { useAuth } from "../hooks/useAuth";

const ProtectedRoute = (allowedRoles) => {
  const { user, loading } = useAuth();

  if (loading) {
    return null;
  }

  if (!user) {
    return <NotAuthorized />;
  }

  const userRole = user?.role;

  const rolesArray = Array.isArray(allowedRoles)
    ? allowedRoles
    : [allowedRoles];

  const isAuthorized = rolesArray.includes(userRole);

  return isAuthorized ? <Outlet /> : <NotAuthorized />;
};

export default ProtectedRoute;
